export default {
      id: "dzen-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "app/svg/sprite.svg#dzen",
      toString: function () {
        return this.url;
      }
    }